import axios from 'axios';

class SoundsSearcher {
    constructor() {
        this.selectedTags = [];
        this.selectedOrTags = [];
        this.selectedStyles = [];
        this.selectedCountries = [];
        this.selectedVideos = [];
        this.selectedDiscogs = [];
        this.filterFavorites = false;
        this.year = undefined;
        this.chord = undefined;
        /*
        this.toDate = new Date();
        this.fromDate = new Date();
        this.fromDate.setDate(this.fromDate.getDate() - 60);
        */
    }

    toString() {
        console.log('selectedTags = ' + this.selectedTags.join(','));
        console.log('selectedOrTags = ' + this.selectedOrTags.join(','));
        console.log('selectedStyles= ' + this.selectedStyles.join(','));
        console.log('selectedCountries = = ' + this.selectedCountries.join(','));
    }

    empty() {
        return this.selectedTags.length == 0 &&
            this.selectedStyles.length == 0 &&
            this.selectedOrTags.length == 0 &&
            this.selectedCountries.length == 0 &&
            this.chord === undefined &&
            this.year == undefined;
    }

    getSearchQueryParameters() {
        let url = '?' +
            'tags=' + this.selectedTags.join(',') + '&styles=' + this.selectedStyles.join(',') +
            '&countries=' + this.selectedCountries.join(',');

        if (this.year !== undefined) {
            url += '&year=' + this.year;
        }
        return url;
    }

    getTopTags() {
        return this.getTopFields('/getTags');
    }

    getTopStyles() {
        return this.getTopFields('/getStyles');
    }

    getTopCountries() {
        return this.getTopFields('/getCountries');
    }

    getTopFields(url) {
        return new Promise((resolve, reject) => {
            let params = this.getSearchQueryParameters();
            url = url + params;
            axios.get(url)
                .then((ret) => {
                    var data = ret.data.data;
                    var fields = [];
                    for (var field in data) {
                        fields.push(field);
                    }

                    resolve(fields);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    async getSounds(start, size) {
        let url = '/filterSearch/' + start + '/' + size + 
            this.getSearchQueryParameters();
        
        let ret = await axios.get(url);
        return this.searchCallback(ret);
    }

    searchCallback(ret) {
        var data = ret.data.data;
        var soundIds = [];
        for (var i=0; i < data.length; i++) {
            soundIds.push(data[i].id);
        }
        let total = ret.data.total;

        return {
            sounds: soundIds,
            total: total};
    }
     
}

export default SoundsSearcher;
